import React from "react";
import type { ConceptBrief } from "../concept/ConceptType";
import {
  extractMentionedConcepts,
  renderViewpointConceptLinkedText,
} from "./ViewpointConceptUtil";

export function ViewpointConceptLinkedBody(props: {
  content: string;
  catalog: ConceptBrief[];
  onConceptClick: (concept: ConceptBrief) => void;
  importancePrefix?: React.ReactNode;
  hotBadge?: React.ReactNode;
}): JSX.Element {
  const { content, catalog, onConceptClick, importancePrefix, hotBadge } = props;
  const linked = renderViewpointConceptLinkedText(content, catalog, onConceptClick);
  return (
    <div className="lf-vp-card__body">
      {importancePrefix}
      {hotBadge}
      {linked}
    </div>
  );
}

export function ViewpointConceptTagRow(props: {
  content: string;
  catalog: ConceptBrief[];
  onConceptClick: (concept: ConceptBrief) => void;
  suffix?: React.ReactNode;
}): JSX.Element | null {
  const { content, catalog, onConceptClick, suffix } = props;
  const mentioned = extractMentionedConcepts(content, catalog);
  if (mentioned.length === 0 && !suffix) {
    return null;
  }
  return (
    <div className="lf-vp-card__concept-row" aria-label="提及的概念">
      {mentioned.length > 0 ? (
        <>
          <span className="lf-vp-card__concept-row-label">关联概念</span>
          <div className="lf-vp-card__concept-tags">
            {mentioned.map((c) => (
              <button
                key={c.code}
                type="button"
                className="lf-vp-card__concept-tag"
                onClick={(e) => {
                  e.stopPropagation();
                  onConceptClick(c);
                }}
              >
                {c.name.trim()}
              </button>
            ))}
          </div>
        </>
      ) : null}
      {suffix}
    </div>
  );
}
